import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="top-center"
      closeButton={true}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-zom-black group-[.toaster]:text-zom-white group-[.toaster]:border-2 group-[.toaster]:border-zom-yellow group-[.toaster]:shadow-brutal group-[.toaster]:font-heading",
          description: "group-[.toast]:text-zom-white/70 group-[.toast]:font-body",
          actionButton:
            "group-[.toast]:bg-zom-yellow group-[.toast]:text-zom-black group-[.toast]:font-heading",
          cancelButton:
            "group-[.toast]:bg-zom-white/20 group-[.toast]:text-zom-white group-[.toast]:font-heading",
          closeButton:
            "group-[.toast]:bg-zom-black group-[.toast]:text-zom-white group-[.toast]:border group-[.toast]:border-zom-white group-[.toast]:hover:bg-zom-red group-[.toast]:hover:text-zom-white group-[.toast]:hover:border-zom-red",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
